import { gql } from '@apollo/client';
import { PageInfoFragment } from '../fragments';
import { SearchItemFragment } from './fragments';

export const SEARCH_QUERY = gql`
  query search(
    $term: String
    $types: [SearchEntityType!]!
    $schemaIds: [ID!]!
    $categoryIds: [ID!]!
    $editorIds: [ID!]!
    $failedReports: Boolean!
    $lastUpdateDateRange: DateRangeInput
    $timezone: String
    $isDisabled: Boolean
    $favoriteOnly: Boolean!
    $queryTypes: [QueryType!]!
    $pagination: Pagination!
    $activeSchemas: Boolean!
  ) {
    search(
      term: $term
      types: $types
      schemaIds: $schemaIds
      categoryIds: $categoryIds
      editorIds: $editorIds
      failedReports: $failedReports
      lastUpdateDateRange: $lastUpdateDateRange
      timezone: $timezone
      isDisabled: $isDisabled
      favoriteOnly: $favoriteOnly
      queryTypes: $queryTypes
      pagination: $pagination
      activeSchemas: $activeSchemas
    ) {
      entities {
        ...SearchItemFields
      }
      pageInfo {
        ...PageInfoFields
      }
    }
  }
  ${SearchItemFragment}
  ${PageInfoFragment}
`;
